import module from 'nominas/finiquito/module.js'
import template from './template.html'

const diferenciaDias = (fechaInicial, fechaFinal) => {
  return Math.max(0, Math.ceil((fechaFinal.getTime() - fechaInicial.getTime()) / (1000 * 3600 * 24))) + 1
}

export class NominasFiniquitoEscenarioConfiguracionComponent {
  editable
  data
  onChange

  $onChanges (changes) {
    if (changes.data && !this.data.colaborador.status_calculado) {
      this.calcularDias()
    }
  }

  calcularDias () {
    if (this.data.colaborador.config.fecha_imss_alta && this.data.colaborador.config.fecha_imss_baja) {
      this.calcularDiasAguinaldo()
      this.calcularDiasVacaciones()
      this.calcularDiasTrabajados()
    } else {
      this.data.colaborador.config.dias_trabajados_aguinaldo = null
      this.data.colaborador.config.dias_trabajados = null
      this.data.colaborador.config.dias_carga_social = null
      this.data.colaborador.config.dias_trabajados_vacaciones = null
    }

    this.modificado()
  }

  calcularDiasAguinaldo () {
    let fechaInicial = new Date(this.data.colaborador.config.fecha_imss_baja.getFullYear(), 0, 1, 0, 0, 0)
    let fechaFinal = this.data.colaborador.config.fecha_imss_baja

    if (this.data.colaborador.config.fecha_imss_alta > fechaInicial) {
      fechaInicial = this.data.colaborador.config.fecha_imss_alta
    }

    this.data.colaborador.config.dias_trabajados_aguinaldo = diferenciaDias(fechaInicial, fechaFinal)

    let aguinaldo = this.encontrarPercepcion(24)

    if (aguinaldo) {
      aguinaldo.importe = aguinaldo.dias = aguinaldo.gravado = aguinaldo.exento = null
    }
  }

  calcularDiasTrabajados () {
    const ultimaNominaFecha = (this.data.colaborador.ultima_nomina && this.data.colaborador.ultima_nomina.fecha_final) || null
    const fechaInicial = ultimaNominaFecha || this.data.colaborador.config.fecha_imss_alta
    const fechaFinal = this.data.colaborador.config.fecha_imss_baja

    this.data.colaborador.config.dias_trabajados = diferenciaDias(fechaInicial, fechaFinal) - (ultimaNominaFecha ? 1 : 0)
    this.data.colaborador.config.dias_carga_social = this.data.colaborador.config.dias_trabajados
  }

  calcularDiasVacaciones () {
    let fechaInicial = this.data.colaborador.config.fecha_imss_alta
    let fechaFinal = this.data.colaborador.config.fecha_imss_baja
    let dias = 0

    while (fechaInicial <= fechaFinal) {
      dias = diferenciaDias(fechaInicial, fechaFinal)

      fechaInicial = new Date(fechaInicial.getFullYear() + 1, fechaInicial.getMonth(), fechaInicial.getDate())
    }

    this.data.colaborador.config.dias_trabajados_vacaciones = dias

    let vacaciones = this.encontrarPercepcion(19)

    if (vacaciones) {
      vacaciones.importe = vacaciones.dias = vacaciones.gravado = vacaciones.exento = null
    }

    let primaVacaciones = this.encontrarPercepcion(20)

    if (vacaciones) {
      primaVacaciones.importe = primaVacaciones.dias = primaVacaciones.gravado = primaVacaciones.exento = null
    }
  }

  calcularSalarioDiarioOrdinario () {
    this.data.colaborador.config.salario_diario_ordinario = parseFloat((this.data.colaborador.config.salario_mensual_ordinario / 30.4).toFixed(2))
    this.modificado()
  }

  calcularSalarioMensualOrdinario () {
    this.data.colaborador.config.salario_mensual_ordinario = parseFloat((this.data.colaborador.config.salario_diario_ordinario * 30.4).toFixed(2))
    this.modificado()
  }

  encontrarPercepcion (id_concepto) {
    return this.data.colaborador.percepciones.find((item) => item.id_concepto === id_concepto)
  }

  modificado () {
    this.onChange({$event: {data: this.data}})
  }
}

module.component('nominasFiniquitoEscenarioConfiguracion', {
  controller: NominasFiniquitoEscenarioConfiguracionComponent,
  template,
  bindings: {
    editable: '<',
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/finiquito/components/escenario/configuracion/component.js